import axios, { AxiosResponse } from 'axios'

// const API_BASE_URL = 'http://13.231.243.39:5001'
// const API_BASE_URL = 'http://192.168.31.211:5001'
const API_BASE_URL = process.env.L2_API_URL
//region 请求和响应类型定义 139.9.2.221 7719

export interface ApiResponse<T> {
  code: number
  data: T | null
  errorMsg: string
}

export interface SecurityCountRequest {
  market: number // 0->深圳, 1->上海
}

export interface SecurityCountResponse {
  count: number
  error_info: string
}

export interface SecurityListRequest {
  market: number // 0->深圳, 1->上海
  start: number
  count: number
}

export interface SecurityListResponse {
  result: string
  actual_count: number
  error_info: string
}

export interface GetBarsRequest {
  category: number
  market: number // 0->深圳, 1->上海
  zqdm: string
  start: number
  count: number
}

export interface GetBarsResponse {
  result: string
  actual_count: number
  error_info: string
}

export interface GetMinuteTimeDataRequest {
  market: number // 0->深圳, 1->上海
  zqdm: string
}

export interface GetMinuteTimeDataResponse {
  result: string
  error_info: string
}

export interface GetHistoryMinuteTimeDataRequest {
  market: number // 0->深圳, 1->上海
  zqdm: string
  date: number
}

export interface GetHistoryMinuteTimeDataResponse {
  result: string
  error_info: string
}

export interface GetTransactionDataRequest {
  market: number // 0->深圳, 1->上海
  zqdm: string
  start: number
  count: number
}

export interface GetTransactionDataResponse {
  result: string
  actual_count: number
  error_info: string
}

export interface GetHistoryTransactionDataRequest {
  market: number // 0->深圳, 1->上海
  zqdm: string
  start: number
  count: number
  date: number
}

export interface GetHistoryTransactionDataResponse {
  result: string
  actual_count: number
  error_info: string
}

export interface GetSecurityQuotesRequest {
  markets: number[] // 0->深圳, 1->上海
  zqdms: string[]
}

export interface GetSecurityQuotesResponse {
  result: string
  actual_count: number
  error_info: string
}

export interface GetCompanyInfoCategoryRequest {
  market: number // 0->深圳, 1->上海
  zqdm: string
}

export interface GetCompanyInfoCategoryResponse {
  result: string
  error_info: string
}

export interface GetCompanyInfoContentRequest {
  market: number // 0->深圳, 1->上海
  zqdm: string
  file_name: string
  start: number
  length: number
}

export interface GetCompanyInfoContentResponse {
  result: string
  error_info: string
}

export interface GetXDXRInfoRequest {
  markets: number[] // 0->深圳, 1->上海
  zqdms: string[]
  count: number
}

export interface GetXDXRInfoResponse {
  result: string
  error_info: string
}

export interface GetFinanceInfoRequest {
  markets: number[] // 0->深圳, 1->上海
  zqdms: string[]
  count: number
}

export interface GetFinanceInfoResponse {
  result: string
  error_info: string
}

export interface GetCallAuctionDataRequest {
  market: number // 0->深圳, 1->上海
  zqdm: string
  start: number
  count: number
}

export interface GetCallAuctionDataResponse {
  result: string
  actual_count: number
  error_info: string
}

export interface GetSecurityQuotes10Request {
  markets: number[] // 0->深圳, 1->上海
  zqdms: string[]
}

export interface GetSecurityQuotes10Response {
  result: string
  actual_count: number
  error_info: string
}

export interface GetBuySellQueueRequest {
  markets: number[] // 0->深圳, 1->上海
  zqdms: string[]
  count: number
}

export interface GetBuySellQueueResponse {
  result: string
  error_info: string
}

export interface GetDetailTransactionDataRequest {
  market: number // 0->深圳, 1->上海
  zqdm: string
  start: number
  count: number
}

export interface GetDetailTransactionDataResponse {
  result: string
  actual_count: number
  error_info: string
}

export interface GetDetailOriginalTransactionDataRequest {
  market: number // 0->深圳, 1->上海
  zqdm: string
  start: number
  count: number
}

export interface GetDetailOriginalTransactionDataResponse {
  result: string
  actual_count: number
  error_info: string
}

export interface GetDetailOrderDataRequest {
  market: number // 0->深圳, 1->上海
  zqdm: string
  start: number
  count: number
}

export interface GetDetailOrderDataResponse {
  result: string
  actual_count: number
  error_info: string
}

//endregion

//region API 请求函数

const handleRequestError = (error: any): ApiResponse<any> => {
  let errorMsg = error.message
  if (error.response && error.response.data && error.response.data.detail) {
    errorMsg = error.response.data.detail
  }
  return { code: -1, data: {}, errorMsg }
}

/**
 * 获取市场内所有证券的数量
 * @param data 请求参数
 * @returns 证券数量
 */
export const getSecurityCount = async (
  data: SecurityCountRequest
): Promise<ApiResponse<SecurityCountResponse>> => {
  try {
    const response: AxiosResponse<SecurityCountResponse> =
      await axios.post<SecurityCountResponse>(
        `${API_BASE_URL}/security_count/`,
        data
      )
    return { code: 0, data: response.data, errorMsg: '' }
  } catch (error: any) {
    return handleRequestError(error)
  }
}

/**
 * 获取市场内从某个位置开始的股票代码
 * @param data 请求参数
 * @returns 股票代码列表
 */
export const getSecurityList = async (
  data: SecurityListRequest
): Promise<ApiResponse<SecurityListResponse>> => {
  try {
    const response: AxiosResponse<SecurityListResponse> =
      await axios.post<SecurityListResponse>(
        `${API_BASE_URL}/security_list/`,
        data
      )
    return { code: 0, data: response.data, errorMsg: '' }
  } catch (error: any) {
    return handleRequestError(error)
  }
}

/**
 * 获取证券的 K 线数据
 * @param data 请求参数
 * @returns K 线数据
 * 参数:
 * connection_id: 连接 ID
 * category: K 线种类, 0->5分钟K线, 1->15分钟K线, 2->30分钟K线, 3->1小时K线, 4->日K线, 5->周K线, 6->月K线, 7->1分钟, 8->1分钟K线, 9->日K线, 10->季K线, 11->年K线
 * market: 市场代码, 0->深圳, 1->上海
 * zqdm: 证券代码
 * start: K 线开始位置, 最后一条 K 线位置是 0, 前一条是 1, 依此类推
 * count: API 执行前, 表示用户要请求的 K 线数目 (最大 800)
 */
export const getSecurityBars = async (
  data: GetBarsRequest
): Promise<ApiResponse<GetBarsResponse>> => {
  try {
    const response: AxiosResponse<GetBarsResponse> =
      await axios.post<GetBarsResponse>(`${API_BASE_URL}/security_bars/`, data)
    return { code: 0, data: response.data, errorMsg: '' }
  } catch (error: any) {
    return handleRequestError(error)
  }
}

/**
 * 获取指数的 K 线数据
 * @param data 请求参数
 * @returns K 线数据
 */
export const getIndexBars = async (
  data: GetBarsRequest
): Promise<ApiResponse<GetBarsResponse>> => {
  try {
    const response: AxiosResponse<GetBarsResponse> =
      await axios.post<GetBarsResponse>(`${API_BASE_URL}/index_bars/`, data)
    return { code: 0, data: response.data, errorMsg: '' }
  } catch (error: any) {
    return handleRequestError(error)
  }
}

/**
 * 获取分时数据
 * @param data 请求参数
 * @returns 分时数据
 */
export const getMinuteTimeData = async (
  data: GetMinuteTimeDataRequest
): Promise<ApiResponse<GetMinuteTimeDataResponse>> => {
  try {
    const response: AxiosResponse<GetMinuteTimeDataResponse> =
      await axios.post<GetMinuteTimeDataResponse>(
        `${API_BASE_URL}/minute_time_data/`,
        data
      )
    return { code: 0, data: response.data, errorMsg: '' }
  } catch (error: any) {
    return handleRequestError(error)
  }
}

/**
 * 获取历史分时数据
 * @param data 请求参数
 * @returns 历史分时数据
 */
export const getHistoryMinuteTimeData = async (
  data: GetHistoryMinuteTimeDataRequest
): Promise<ApiResponse<GetHistoryMinuteTimeDataResponse>> => {
  try {
    const response: AxiosResponse<GetHistoryMinuteTimeDataResponse> =
      await axios.post<GetHistoryMinuteTimeDataResponse>(
        `${API_BASE_URL}/history_minute_time_data/`,
        data
      )
    return { code: 0, data: response.data, errorMsg: '' }
  } catch (error: any) {
    return handleRequestError(error)
  }
}

/**
 * 获取分时成交数据
 * @param data 请求参数
 * @returns 分时成交数据
 */
export const getTransactionData = async (
  data: GetTransactionDataRequest
): Promise<ApiResponse<GetTransactionDataResponse>> => {
  try {
    const response: AxiosResponse<GetTransactionDataResponse> =
      await axios.post<GetTransactionDataResponse>(
        `${API_BASE_URL}/transaction_data/`,
        data
      )
    return { code: 0, data: response.data, errorMsg: '' }
  } catch (error: any) {
    return handleRequestError(error)
  }
}

/**
 * 获取历史分时成交数据
 * @param data 请求参数
 * @returns 历史分时成交数据
 */
export const getHistoryTransactionData = async (
  data: GetHistoryTransactionDataRequest
): Promise<ApiResponse<GetHistoryTransactionDataResponse>> => {
  try {
    const response: AxiosResponse<GetHistoryTransactionDataResponse> =
      await axios.post<GetHistoryTransactionDataResponse>(
        `${API_BASE_URL}/history_transaction_data/`,
        data
      )
    return { code: 0, data: response.data, errorMsg: '' }
  } catch (error: any) {
    return handleRequestError(error)
  }
}

/**
 * 批量获取多个证券的五档报价数据
 * @param data 请求参数
 * @returns 五档报价数据
 */
export const getSecurityQuotes = async (
  data: GetSecurityQuotesRequest
): Promise<ApiResponse<GetSecurityQuotesResponse>> => {
  try {
    const response: AxiosResponse<GetSecurityQuotesResponse> =
      await axios.post<GetSecurityQuotesResponse>(
        `${API_BASE_URL}/security_quotes/`,
        data
      )
    return { code: 0, data: response.data, errorMsg: '' }
  } catch (error: any) {
    return handleRequestError(error)
  }
}

/**
 * 获取 F10 资料的分类
 * @param data 请求参数
 * @returns F10 资料分类
 */
export const getCompanyInfoCategory = async (
  data: GetCompanyInfoCategoryRequest
): Promise<ApiResponse<GetCompanyInfoCategoryResponse>> => {
  try {
    const response: AxiosResponse<GetCompanyInfoCategoryResponse> =
      await axios.post<GetCompanyInfoCategoryResponse>(
        `${API_BASE_URL}/company_info_category/`,
        data
      )
    return { code: 0, data: response.data, errorMsg: '' }
  } catch (error: any) {
    return handleRequestError(error)
  }
}

/**
 * 获取 F10 资料的某一分类的内容
 * @param data 请求参数
 * @returns F10 资料内容
 */
export const getCompanyInfoContent = async (
  data: GetCompanyInfoContentRequest
): Promise<ApiResponse<GetCompanyInfoContentResponse>> => {
  try {
    const response: AxiosResponse<GetCompanyInfoContentResponse> =
      await axios.post<GetCompanyInfoContentResponse>(
        `${API_BASE_URL}/company_info_content/`,
        data
      )
    return { code: 0, data: response.data, errorMsg: '' }
  } catch (error: any) {
    return handleRequestError(error)
  }
}

/**
 * 获取除权除息信息
 * 参数:
 * - connection_id:连接 ID
 * - markets:市场代码数组, 0->深圳, 1->上海
 * - zqdms: 证券代码数组
 * - count: API 执行前, 表示用户要请求的证券数目
 * @param data 请求参数
 * @returns 除权除息信息
 */
export const getXDXRInfo = async (
  data: GetXDXRInfoRequest
): Promise<ApiResponse<GetXDXRInfoResponse>> => {
  try {
    const response: AxiosResponse<GetXDXRInfoResponse> =
      await axios.post<GetXDXRInfoResponse>(`${API_BASE_URL}/xdxr_info/`, data)
    return { code: 0, data: response.data, errorMsg: '' }
  } catch (error: any) {
    return handleRequestError(error)
  }
}

/**
 * 获取财务信息
 * @param data 请求参数
 * @returns 财务信息
 */
export const getFinanceInfo = async (
  data: GetFinanceInfoRequest
): Promise<ApiResponse<GetFinanceInfoResponse>> => {
  try {
    const response: AxiosResponse<GetFinanceInfoResponse> =
      await axios.post<GetFinanceInfoResponse>(
        `${API_BASE_URL}/finance_info/`,
        data
      )
    return { code: 0, data: response.data, errorMsg: '' }
  } catch (error: any) {
    return handleRequestError(error)
  }
}

/**
 * 获取集合竞价数据
 * @param data 请求参数
 * @returns 集合竞价数据
 */
export const getCallAuctionData = async (
  data: GetCallAuctionDataRequest
): Promise<ApiResponse<GetCallAuctionDataResponse>> => {
  try {
    const response: AxiosResponse<GetCallAuctionDataResponse> =
      await axios.post<GetCallAuctionDataResponse>(
        `${API_BASE_URL}/call_auction_data/`,
        data
      )
    return { code: 0, data: response.data, errorMsg: '' }
  } catch (error: any) {
    return handleRequestError(error)
  }
}

/**
 * 批量获取多个证券的十档报价数据
 * @param data 请求参数
 * @returns 十档报价数据
 */
export const getSecurityQuotes10 = async (
  data: GetSecurityQuotes10Request
): Promise<ApiResponse<GetSecurityQuotes10Response>> => {
  try {
    const response: AxiosResponse<GetSecurityQuotes10Response> =
      await axios.post<GetSecurityQuotes10Response>(
        `${API_BASE_URL}/security_quotes_10/`,
        data
      )
    return { code: 0, data: response.data, errorMsg: '' }
  } catch (error: any) {
    return handleRequestError(error)
  }
}

/**
 * 获取买卖队列数据
 * @param data 请求参数
 * @returns 买卖队列数据
 */
export const getBuySellQueue = async (
  data: GetBuySellQueueRequest
): Promise<ApiResponse<GetBuySellQueueResponse>> => {
  try {
    const response: AxiosResponse<GetBuySellQueueResponse> =
      await axios.post<GetBuySellQueueResponse>(
        `${API_BASE_URL}/buy_sell_queue/`,
        data
      )
    return { code: 0, data: response.data, errorMsg: '' }
  } catch (error: any) {
    return handleRequestError(error)
  }
}

/**
 * 获取逐笔成交数据
 * @param data 请求参数
 * @returns 逐笔成交数据
 */
export const getDetailTransactionData = async (
  data: GetDetailTransactionDataRequest
): Promise<ApiResponse<GetDetailTransactionDataResponse>> => {
  try {
    const response: AxiosResponse<GetDetailTransactionDataResponse> =
      await axios.post<GetDetailTransactionDataResponse>(
        `${API_BASE_URL}/detail_transaction_data/`,
        data
      )
    return { code: 0, data: response.data, errorMsg: '' }
  } catch (error: any) {
    return handleRequestError(error)
  }
}

/**
 * 获取逐笔还原数据
 * @param data 请求参数
 * @returns 逐笔还原数据
 */
export const getDetailOriginalTransactionData = async (
  data: GetDetailOriginalTransactionDataRequest
): Promise<ApiResponse<GetDetailOriginalTransactionDataResponse>> => {
  try {
    const response: AxiosResponse<GetDetailOriginalTransactionDataResponse> =
      await axios.post<GetDetailOriginalTransactionDataResponse>(
        `${API_BASE_URL}/detail_original_transaction_data/`,
        data
      )
    return { code: 0, data: response.data, errorMsg: '' }
  } catch (error: any) {
    return handleRequestError(error)
  }
}

/**
 * 获取逐笔委托数据
 * @param data 请求参数
 * @returns 逐笔委托数据
 */
export const getDetailOrderData = async (
  data: GetDetailOrderDataRequest
): Promise<ApiResponse<GetDetailOrderDataResponse>> => {
  try {
    const response: AxiosResponse<GetDetailOrderDataResponse> =
      await axios.post<GetDetailOrderDataResponse>(
        `${API_BASE_URL}/detail_order_data/`,
        data
      )
    return { code: 0, data: response.data, errorMsg: '' }
  } catch (error: any) {
    return handleRequestError(error)
  }
}

//endregion